export default __webpack_public_path__ + "static/media/bgs.6d0d6e11.png";